<template>
	<div class="portal-page docs-page">
		<section class="portal-section portal-section--compact">
			<div class="portal-section__head">
				<h1>文档中心</h1>
				<p>统一整理部署、产品说明、第三方能力接入和业务使用说明。</p>
			</div>
		</section>

		<section class="portal-grid">
			<article class="portal-card" v-for="doc in docs" :key="doc.title">
				<h3>{{ doc.title }}</h3>
				<p>{{ doc.desc }}</p>
				<a v-if="doc.external" :href="doc.external" target="_blank" rel="noopener noreferrer">打开文档</a>
				<a v-else @click.prevent="$router.push({ name: doc.routeName })">进入页面</a>
			</article>
		</section>
	</div>
</template>

<script>
export default {
	name: 'Docs',
	data() {
		return {
			docs: [
				{ title: 'XSender 安装文档', desc: '办公室页采用的智能发送器文档和安装说明。', external: 'https://jianfv.top/XSender/guide/install' },
				{ title: '财税平台说明', desc: '聚焦凭证、报表、账簿、设置等财税后台工作流。', routeName: 'Home' }
			]
		};
	}
};
</script>
